import { useEffect, useState } from 'react';

import {
  closeResearchAssistant,
  openResearchAssistant,
} from '@verantos-dev/app-state-research-assistant';

interface UseAutoOpenRAOptions {
  /** Whether the conditions are met and RA is ready to auto-open */
  readyToOpen: boolean;
  /** Whether to close RA when component unmounts (default: true) */
  closeOnUnmount?: boolean;
}

/**
 * Reusable hook for auto-opening RA
 *
 * @param options - Configuration object with readyToOpen boolean and optional closeOnUnmount
 */
export const useAutoOpenRA = ({ readyToOpen, closeOnUnmount = true }: UseAutoOpenRAOptions) => {
  const [hasAutoOpened, setHasAutoOpened] = useState(false);

  useEffect(() => {
    if (!hasAutoOpened && readyToOpen) {
      openResearchAssistant();
      setHasAutoOpened(true);
    }
  }, [hasAutoOpened, readyToOpen]);

  useEffect(() => {
    if (!closeOnUnmount) return;

    return () => {
      closeResearchAssistant();
    };
  }, [closeOnUnmount]);

  return { hasAutoOpened };
};
